import { useEffect } from 'react';
import Container from 'components/shared/generic/container/presentational/Container';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import AccountOverview from './AccountOverview';
import { useLocation } from 'react-router-dom';
import { useGetAccountQuery, useGetCardsQuery } from 'lib/services';
import { IAccount } from 'lib/type';

const AccountOverviewContainer = () => {
    const jwt = localStorage.getItem('accessToken');
    const {
        data: account,
        isLoading: isAccountLoading,
        error: accountError,
        refetch: refetchAccount,
    } = useGetAccountQuery();

    useGetCardsQuery();

    const isLoading = isAccountLoading;
    const error = accountError;

    const { pathname } = useLocation();

    useEffect(() => {
        if (pathname !== '/more') {
            refetchAccount();
        }
    }, [pathname, refetchAccount, jwt]);

    return (
        <Container>
            <DataCheck data={account} isLoading={isLoading} error={error}>
                <AccountOverview account={account as IAccount} />
            </DataCheck>
        </Container>
    );
};

export default AccountOverviewContainer;
